import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export const useIsQuestionInInbox = (
  studentId?: string | number,
  questionId?: string | number,
  lang?: string,
): {
  questionInInbox: boolean;
  questionInInboxLoading: boolean;
  questionInInboxError: any;
  moveToInbox: (questionId: number) => any;
} => {
  const queryClient = useQueryClient();
  const shouldFetch = !!studentId && !!questionId && !!lang;

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["QuestionInInbox", [studentId, questionId, lang]],
    queryFn: () =>
      fetchQuestionInInbox({
        studentId,
        questionId,
        lang,
      }),
    enabled: shouldFetch,
  });

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ["QuestionInInbox", [studentId, questionId, lang]],
    mutationFn: (value: number) => moveToInbox(value as number),
    onSettled: (response) => {
      queryClient.setQueryData(
        ["QuestionInInbox", [studentId, questionId, lang]],
        () => {
          return true;
        },
      );
    },
  });

  return {
    questionInInbox: data,
    questionInInboxLoading: isLoading || isRefetching || isPending,
    questionInInboxError: error,
    moveToInbox: mutateAsync,
  };
};

function fetchQuestionInInbox(body: any) {
  return axios
    .post(`/api/questions/checkIfInInbox/`, body)
    .then((response) => response.data);
}

function moveToInbox(questionId: number) {
  return axios
    .post(`/api/questions/moveToInbox/`, {
      questionId,
    })
    .then((response) => response.data);
}
